import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import '../css/site.css';

export default function Navigation() {
    const [menuOpen, setMenuOpen] = useState(false);

    const navItems = [
        { to: '/', label: 'Home' },
        { to: '/about', label: 'About' },
        { to: '/patterns', label: 'Free Patterns' },
        { to: '/commissions', label: 'Commissions' },
        { to: '/gallery', label: 'Gallery' }
    ];

    return(
        <header>
            <div className="navigation-bar sticky">
                <div className="navigation-desktop">
                    {navItems.slice(1, 3).map((item) => (
                        <p key={item.to} className="navigation-item"><Link to={item.to}>{item.label}</Link></p>
                    ))}

                    <div className="navigation-item logo-item"><Link to="/"><img id="dango" src="/images/dango_fin.png" alt="Dango logo"/></Link></div>

                    {navItems.slice(3).map((item) => (
                        <p key={item.to} className="navigation-item"><Link to={item.to}>{item.label}</Link></p>
                    ))}
                </div>

                <div className="navigation-mobile">
                    <Link to="/" className="mobile-logo" aria-label="Go to home page">
                        <img id="dango" src="/images/dango_fin.png" alt="Dango logo"/>
                    </Link>

                    <button
                        type="button"
                        className={`hamburger-button ${menuOpen ? 'open' : ''}`}
                        onClick={() => setMenuOpen((previous) => !previous)}
                        aria-label="Toggle navigation"
                        aria-expanded={menuOpen}
                    >
                        <span />
                        <span />
                        <span />
                    </button>
                </div>

                {menuOpen && (
                    <nav className="mobile-nav-panel" aria-label="Mobile navigation">
                        {navItems.map((item) => (
                            <Link key={item.to} to={item.to} onClick={() => setMenuOpen(false)}>
                                {item.label}
                            </Link>
                        ))}
                    </nav>
                )}
            </div>
        </header>
    );
}